import { Link } from "react-router-dom";
import { generalFaqs, product } from "../content/site";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faqs() {
  return (
    <div data-testid="faqs-page">
      <PageHeader
        eyebrow="FAQs"
        title="Asked, answered."
        body="The questions we hear most, answered plainly. For product-specific detail, see the Magnesium Glycinate page — or write to us directly."
      />
      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
        <Reveal>
          <Accordion type="single" collapsible data-testid="faqs-accordion">
            {generalFaqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-stone-900/15" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-6 text-left font-serif text-xl font-light text-stone-900 hover:no-underline [&>svg]:text-emerald-900">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-7 text-sm leading-relaxed text-stone-600">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-14 flex flex-wrap items-center justify-between gap-6 border-t border-stone-900/10 pt-10">
            <p className="text-sm text-stone-600">Still wondering something?</p>
            <div className="flex gap-4">
              <Link
                to={`/product/${product.slug}`}
                data-testid="faqs-product-link"
                className="border border-stone-900 px-6 py-3 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-stone-900 transition-colors duration-300 hover:bg-stone-900 hover:text-stone-50"
              >
                Product FAQs
              </Link>
              <Link
                to="/contact"
                data-testid="faqs-contact-link"
                className="bg-stone-900 px-6 py-3 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-stone-50 transition-colors duration-300 hover:bg-emerald-900"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
